import { Injectable } from '@angular/core';
import { CartConfigService, CartService, CartRow } from 'gung-standard';
import { ListLayout } from 'gung-list';
import { RefCartItemComponent } from '../../components/cart/ref-cart-item/ref-cart-item.component';
import { RefCartListLayoutComponent } from '../../components/cart/ref-cart-list-layout/ref-cart-list-layout.component';

@Injectable({
  providedIn: 'root'
})
export class RefCartConfigService extends CartConfigService {
  getLayouts(): ListLayout<CartRow>[] {
    return [
      {
        getIconClass: () => '',
        getName: () => 'Cart table',
        getListItemComponent: () => RefCartItemComponent,
        getListLayoutComponent: () => RefCartListLayoutComponent
      }
    ];
  }
}
